import { EffectCallback, useEffect } from 'react';

/**
 * A hook that debounces an effect.
 * @param effect - The effect to debounce.
 * @param delay - The delay in milliseconds.
 * @param deps - The dependencies to watch.
 * @returns void.
 */
export const useDebouncedEffect = (
    effect: EffectCallback,
    delay: number,
    deps: unknown[]
) => {
    useEffect(() => {
        const timer = setTimeout(() => effect(), delay);

        return () => clearTimeout(timer);
    }, deps);
};
